import React from 'react';
import PropTypes from 'prop-types';
import { ServicingSection } from 'web-ui-components/lib/global/layout';
import AccountsStore from '../../stores/AccountsStore';
import envConfig from '../../../static/config';
import DetermineAccountPicker from './DetermineAccountPicker';
import ManagePaymentsSMEDropDown from './ManagePaymentsSMEDropDown';
import {
  getSelectedAccount,
  handleChooseAccountFromPicker,
} from './ManagePaymentsSMEUtils';
import FavouritesStore from '../../stores/AccountsStore/FavouritesStore';

const ManagePaymentsSMERenderPicker = ({
  selectedAccountId,
  dropDownProps,
  content,
}) => {
  if (
    !envConfig.isLcvEnabled ||
    AccountsStore.getTotalNumberOfAccounts() <= 1
  ) {
    return null;
  }
  const accounts = AccountsStore.getAll();
  return (
    <ServicingSection>
      <DetermineAccountPicker
        numberOfAccounts={accounts.length}
        isLargeCustomerView={FavouritesStore.isLargeCustomer()}
        selectedAccount={getSelectedAccount(selectedAccountId)}
        onChooseAccount={handleChooseAccountFromPicker}
        content={content}
        renderDropDown={() => (
          <ManagePaymentsSMEDropDown
            label={content.accountPickerTitle}
            dropDownProps={dropDownProps}
          />
        )}
        chooseAccountText={content.accountPickerManagePaymentsChoose}
      />
    </ServicingSection>
  );
};

ManagePaymentsSMERenderPicker.propTypes = {
  selectedAccountId: PropTypes.string,
  dropDownProps: PropTypes.shape({
    selectedAccount: PropTypes.object,
    onDropdownSelect: PropTypes.func.isRequired,
    accountList: PropTypes.array.isRequired,
  }),
  content: PropTypes.shape({
    accountPickerTitle: PropTypes.string.isRequired,
    accountPickerManagePaymentsChoose: PropTypes.string.isRequired,
  }),
};

export default ManagePaymentsSMERenderPicker;
